import { render, staticRenderFns } from "./EditaCuenta.vue?vue&type=template&id=6fd7112a"
import script from "./EditaCuenta.vue?vue&type=script&lang=js"
export * from "./EditaCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports